import clsx from 'clsx';
import { Typography, TypographyType } from 'components/common';

interface Props {
	children: React.ReactNode;
	description?: string | React.ReactElement;
	className?: string;
	classNameTitle?: string;
	classNameDescription?: string;
	typographyDescription?: TypographyType;
	typographyTitle?: TypographyType;
}

export const Title: React.FC<Props> = ({
	description,
	className,
	classNameTitle,
	classNameDescription,
	children,
	typographyTitle,
	typographyDescription,
}) => {
	return (
		<div
			className={clsx(
				'w-full flex flex-col gap-4 justify-center items-center',
				className
			)}
		>
			<Typography
				type={typographyTitle ?? 'headline-48'}
				className={clsx('tracking-tight text-center', classNameTitle)}
			>
				{children}
			</Typography>
			{typeof description === 'string' ? (
				<Typography
					type={typographyDescription || 'regular-20'}
					text={description}
					className={clsx('text-center', classNameDescription)}
				/>
			) : (
				description
			)}
		</div>
	);
};
